import { useQuery } from '@tanstack/react-query';
import { getRoverTasks } from '@/api/Rover/applicationTDM';
import type { TdmType } from '@/types/Tdm';
import { getTasks } from '../../../api/Sherpa/Project/modules/ProjectTdm';
import { TdmReactQueryKey } from '../../../constants/ReactQueryKeys';
import { sherpaTdmListQueryKey } from '../../../features/projects/query-cache';
import type { QueryParamsInterface } from '../../../types/Shared';

interface ITasksHookProps {
  tdmType?: TdmType;
  params?: QueryParamsInterface;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
  enabled?: boolean;
}

export const useTasks = ({ params, onSuccess, onError, enabled }: ITasksHookProps) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: sherpaTdmListQueryKey('task', params),
    queryFn: () => getTasks({ params }),
    enabled,
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: 30000,
  });
};

export const useRoverTasks = ({ params, onSuccess, onError }: ITasksHookProps) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: [TdmReactQueryKey.GET_APPLICATION_TASKS, params],
    queryFn: () => getRoverTasks({ params }),
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: 30000,
  });
};
